// Settings shell strings — EN + TR.
//
// Wave-2 Day 1. Full-page overlay Settings (Shopify pattern) chrome:
// title + section/group nav labels + search placeholder + empty-state
// "no matches for X" parametric helper. Cross-shell visible (admin /
// seller / supply hepsi Settings overlay'i açar).
//
// Source: features/settings/Settings.tsx.

import type { LocalizedDict } from '../index'

type SettingsShellStrings = {
  title: string
  searchPlaceholder: string
  noMatches: (query: string) => string
  selectSection: string
  sectionPickerLabel: string
  closeAriaLabel: string
  editAriaLabel: (target: string) => string
  header: {
    storeCount: (n: number) => string
    noStores: string
  }
  groups: {
    organization: string
    store: string
    platformMaster: string
    system: string
  }
  sections: {
    organization: string
    users: string
    employeeTracking: string
    plan: string
    shippingTags: string
    shippingPrinting: string
    storeIntegrations: string
    listingMapping: string
    shipstation: string
    walletPreferences: string
    notifications: string
    security: string
    appearance: string
    languages: string
  }
}

export const settingsShellI18n: LocalizedDict<SettingsShellStrings> = {
  en: {
    title: 'Settings',
    searchPlaceholder: 'Search settings',
    noMatches: (q) => `No matches for "${q}".`,
    selectSection: 'Select a settings section to begin.',
    sectionPickerLabel: 'Settings section',
    closeAriaLabel: 'Close settings',
    editAriaLabel: (target) => `Edit ${target}`,
    header: {
      storeCount: (n) => (n === 1 ? '1 store' : `${n} stores`),
      noStores: 'No stores connected yet',
    },
    groups: {
      organization: 'Organization',
      store: 'Store',
      platformMaster: 'Platform Master',
      system: 'System',
    },
    sections: {
      organization: 'Organization',
      users: 'Users',
      employeeTracking: 'Employee Tracking',
      plan: 'Plan',
      shippingTags: 'Shipping & delivery',
      shippingPrinting: 'Printing setup',
      storeIntegrations: 'Store Integrations',
      listingMapping: 'Listing Mapping',
      shipstation: 'ShipStation',
      walletPreferences: 'Wallet preferences',
      notifications: 'Notifications',
      security: 'Security',
      appearance: 'Appearance',
      languages: 'Languages',
    },
  },
  tr: {
    title: 'Ayarlar',
    searchPlaceholder: 'Ayarlarda ara',
    noMatches: (q) => `"${q}" için eşleşme yok.`,
    selectSection: 'Başlamak için bir ayar bölümü seç.',
    sectionPickerLabel: 'Ayarlar bölümü',
    closeAriaLabel: 'Ayarları kapat',
    editAriaLabel: (target) => `${target} düzenle`,
    header: {
      storeCount: (n) => `${n} mağaza`,
      noStores: 'Henüz bağlı mağaza yok',
    },
    groups: {
      organization: 'Organizasyon',
      store: 'Mağaza',
      platformMaster: 'Platform Yönetimi',
      system: 'Sistem',
    },
    sections: {
      organization: 'Organizasyon',
      users: 'Kullanıcılar',
      employeeTracking: 'Çalışan İzleme',
      plan: 'Plan',
      shippingTags: 'Kargo ve teslimat',
      shippingPrinting: 'Yazdırma ayarları',
      storeIntegrations: 'Mağaza Entegrasyonları',
      listingMapping: 'İlan Eşleştirme',
      shipstation: 'ShipStation',
      walletPreferences: 'Cüzdan tercihleri',
      notifications: 'Bildirimler',
      security: 'Güvenlik',
      appearance: 'Görünüm',
      languages: 'Diller',
    },
  },
}
